import React from "react";
import styles from "./SolarRecommendationFormWrapper.module.scss";
import { ButtonArrow } from "../../../assets/icons";
import FormProgressCircle from "../../../common/components/form-progress-circle/FormProgressCircle";
import { BounceLoader } from "react-spinners";
import RecommendationFormStepHeader from "../../../common/components/form-step-header/RecommendationFormStepHeader";

type Props = {
	title: string;
	subtitle: string;
	labelNext?: string;
	labelBack?: string;
	onNext: () => void;
	onBack: () => void;
	children?: React.ReactNode;
	nextButtonDisabled?: boolean;
	labelNextStep?: string;
	labelBackStep?: string;
	isLoading?: boolean;
	step: number;
	showMobileNext?: boolean;
	showMobileBack?: boolean;
	showDesktopNext?: boolean;
	showDesktopBack?: boolean;
};

const SolarRecommendationFormWrapper: React.FC<Props> = (props: Props) => {
	const {
		children,
		onNext,
		onBack,
		nextButtonDisabled,
		title,
		subtitle,
		isLoading,
		labelNext,
		labelBack,
		labelNextStep,
		labelBackStep,
		step,
		showMobileNext = true,
		showMobileBack = true,
		showDesktopNext = true,
		showDesktopBack = true,
	} = props;

	return (
		<div className={styles.container}>
			<h1 className={styles.title}>{title}</h1>
			<h4 className={styles.subtitle}>{subtitle}</h4>
			<div className={styles.isNotMobile}>
				<FormProgressCircle numberOfSteps={4} activeStep={step} />
			</div>
			<div className={styles.isMobile}>
                <RecommendationFormStepHeader labelNextStep={labelNextStep} labelBackStep={labelBackStep}/>
			</div>
			<div className={styles.content}>
				{children}
				<div className={`${styles.buttonContainer} ${styles.withContent}`}>
					{showDesktopBack && <button className={`standardButton ${styles.button} ${styles.back}`} onClick={onBack}>
						<ButtonArrow />
						{labelBack ?? "Back"}
					</button>}
					{showDesktopNext &&<button className={`standardButton ${styles.button} ${styles.next}`} onClick={onNext} disabled={nextButtonDisabled || isLoading}>
						{isLoading ? (
							<BounceLoader color="#DE841B" size={25} />
						) : (
							<>
								{labelNext ?? "Next"}
								<ButtonArrow />
							</>
						)}
					</button>}
				</div>
			</div>
			<div className={`${styles.buttonContainer} ${styles.mobile}`}>
				{showMobileBack && <button className={`standardButton ${styles.button} ${styles.back}`} onClick={onBack}>
					<ButtonArrow />
					{labelBack ?? "Back"}
				</button>}
				{showMobileNext &&<button className={`standardButton ${styles.button} ${styles.next}`} onClick={onNext} disabled={nextButtonDisabled || isLoading}>
					{isLoading ? (
						<BounceLoader color="#DE841B" size={25} />
					) : (
						<>
							{labelNext ?? "Next"}
							<ButtonArrow />
						</>
					)}
				</button>}
			</div>
		</div>
	);
};

export default SolarRecommendationFormWrapper;
